import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Editor } from "~/components/code/editor";
import type { TemplateVariableSuggestion } from "~/tools/template-variables/definitions";

import { PromQLInput } from "../../../metrics/PromQLInput";

import type { AliasFormState, MinStepFormState, PromqlFormState } from "./form-state";

export interface WidgetQueryPromqlProps {
	className?: string;
	promql: PromqlFormState;
}

export const WidgetQueryPromql: React.FC<WidgetQueryPromqlProps> = ({ className, promql }) => {
	const monitor = useMonitor();

	return (
		<PromQLInput className={className} onChange={(value) => promql.setInput(value)} value={promql.getInput(monitor)} />
	);
};

export interface WidgetQueryAliasProps {
	className?: string;
	alias: AliasFormState;
	suggestions?: ReadonlyArray<TemplateVariableSuggestion>;
}

export const WidgetQueryAlias: React.FC<WidgetQueryAliasProps> = ({ className, alias, suggestions = [] }) => {
	const monitor = useMonitor();

	return (
		<Editor
			appearance="input"
			className={className}
			language={{ name: "template", variables: suggestions }}
			onChange={(text) => alias.setInput(text)}
			placeholder="Example: '${instance}' will generate series names like 'webserver-123', 'webserver-456'..."
			value={alias.getInput(monitor)}
		/>
	);
};

export interface WidgetQueryMinStepProps {
	className?: string;
	minStep: MinStepFormState;
	suggestions?: ReadonlyArray<TemplateVariableSuggestion>;
}

export const WidgetQueryMinStep: React.FC<WidgetQueryMinStepProps> = ({ className, minStep, suggestions = [] }) => {
	const monitor = useMonitor();

	return (
		<Editor
			appearance="input"
			className={className}
			language={{ name: "template", variables: suggestions }}
			onChange={(text) => minStep.setInput(text)}
			placeholder="Auto"
			value={minStep.getInput(monitor)}
		/>
	);
};
